import { useGetQuery } from "../hooks";
import { useParams } from "react-router-dom";
import Panel from "./Panel";
import PerformedJobCRUD from "./PerformedJobCRUD";
import PerformedResponsibilityCRUD from "./PerformedResponsibilityCRUD";
import Stack from "./Stack";
import SubmissionEdit from "./SubmissionEdit";
import LayoutWithNav from "./LayoutWithNav";
import PageHeader from "./PageHeader";
import { ClipboardCheck } from "lucide-react";

function SubmissionTransaction({ submission }) {
  const transactionsQuery = useGetQuery("transactions", {
    queryParams: { submission: submission.id },
    identifier: submission.transaction,
  });

  if (transactionsQuery.isLoading) {
    return null;
  }

  const transaction = transactionsQuery.data;

  if (transaction) {
    return (
      <Panel left="Submission total">
        <p>£{transaction.amount}</p>
      </Panel>
    );
  }
}

export default function SubmissionPage() {
  const { submissionId } = useParams();
  const submissionQuery = useGetQuery("submissions", {
    identifier: submissionId,
  });

  if (submissionQuery.isLoading) {
    return null;
  }

  if (submissionQuery.error) {
    return "Submission not found";
  }

  const submission = submissionQuery.data;

  return (
    <LayoutWithNav>
      <PageHeader icon={<ClipboardCheck className="w-6 h-6" />}>
        Edit submission
      </PageHeader>
      <Stack>
        <Panel left="Edit submission">
          <SubmissionEdit submission={submission} />
        </Panel>
        <PerformedJobCRUD submission={submission} />
        <PerformedResponsibilityCRUD submission={submission} />
        <SubmissionTransaction submission={submission} />
      </Stack>
    </LayoutWithNav>
  );
}
